export default __webpack_public_path__ + "static/media/Icon=Office Locations.768918d5.svg";